export const calculateProgressiveBalances = (sections: any[]) => {
  return sections.map(section => {
    let currentBalance = section.initial_balance || 0;
    
    // Sort movements chronologically by date/timestamp
    const sortedData = [...(section.data || [])].sort((a, b) => {
      const dateA = new Date(a.date).getTime();
      const dateB = new Date(b.date).getTime();
      return dateA - dateB;
    });

    const enrichedMovements = sortedData.map((move: any) => {
      // Impact = Debits - Credits
      const impact = (move.debit || 0) - (move.credit || 0);
      currentBalance += impact;
      
      return {
        ...move,
        progressive_balance: currentBalance
      };
    });

    return {
      ...section,
      enrichedMovements,
      final_balance: currentBalance
    };
  });
};

export const formatCurrency = (value: any, decimals = 0) => {
  return new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  }).format(value);
};
